import * as React from "react";
import { useNavigate, useLocation } from 'react-router-dom';


import {
  Nav,
  NavCategory,
  NavCategoryItem,
  NavDrawer,
  NavDrawerBody,
  NavItem,
  NavSubItem,
  NavSubItemGroup,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";

import { getSidebarConfigForRoute } from '../config/sidebar-config';

const useStyles = makeStyles({
  navDrawer: {
    width: '260px',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('4px'),
    boxShadow: tokens.shadow8,
    ...shorthands.overflow('hidden'),
    marginLeft: '8px',
    '& button': {
      backgroundColor: tokens.colorNeutralBackground1,
      '&:hover': {
        backgroundColor: tokens.colorNeutralBackground1Hover,
      },
    },
  },
  nav: {
    backgroundColor: tokens.colorNeutralBackground1,
  },
});

interface SidebarProps {
  isOpen: boolean;
}

export default function Sidebar({ isOpen }: SidebarProps) {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();




  const sidebarConfig = getSidebarConfigForRoute(location.pathname);

  React.useEffect(() => {
    if (!sidebarConfig) return;

    const pathname = location.pathname;
    const categoriesToOpen: string[] = [];

    // Check which categories match the current path
    for (const item of sidebarConfig) {
      if (item.type === 'category' && item.path && pathname.startsWith(item.path)) {
        categoriesToOpen.push(item.value);
      }
    }
  }, [location.pathname, sidebarConfig]);

  if (!sidebarConfig) {
    return null; // No sidebar for this route
  }

  return (
    // This sidebar is context sensitive - it will display dynamic items based on current route.
    <NavDrawer open={isOpen} type="inline" size="medium" className={styles.navDrawer}>
      <NavDrawerBody>
        <Nav aria-label="Main navigation" className={styles.nav}>
          {sidebarConfig.map((configItem) => {
            if (configItem.type === 'category') {
              return (
                <NavCategory key={configItem.value} value={configItem.value}>
                  <NavCategoryItem
                    onClick={configItem.path ? () => navigate(configItem.path!) : undefined}
                  >
                    {configItem.label}
                  </NavCategoryItem>
                  <NavSubItemGroup>
                    {configItem.items.map((subItem) => (
                      <NavSubItem
                        key={subItem.value}
                        value={subItem.value}
                        onClick={() => navigate(subItem.path)}
                      >
                        {subItem.label}
                      </NavSubItem>
                    ))}
                  </NavSubItemGroup>
                </NavCategory>
              );
            } else {
              return (
                <NavItem
                  key={configItem.value}
                  value={configItem.value}
                  onClick={() => navigate(configItem.path)}
                >
                  {configItem.label}
                </NavItem>
              );
            }
          })}
        </Nav>
      </NavDrawerBody>
    </NavDrawer>
  );
}